export default "__VITE_ASSET__ymkZ$Gx7__"